import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IAddress } from "../_shared/interfaces/IAddress";
import { CustomResponse } from '../_shared/classes/CustomResponse';
import { BaseService } from '../services/base-service.service';

@Injectable({
  providedIn: 'root',
})
export class RiskAddressService extends BaseService{

  constructor(private http: HttpClient) {
    super();
  }

  createAddress(address: IAddress): Observable<CustomResponse<any>> {
    return this.http.post<CustomResponse<any>>(this.buildXenithEndpoint(`/HighValueAddress/Create`), address, this.GetAuthHeaderJson());
  }

  validateAddress(address: IAddress): Observable<CustomResponse<any>> {
    return this.http.post<CustomResponse<any>>(this.buildXenithEndpoint(`/HighValueAddress/Validate`), address, this.GetAuthHeaderJson());
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log("error in service");
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
